module.exports = __webpack_public_path__ + "static/JosefinSans-Regular-38107321b85bfb3bfe4230fb32d6ce83.ttf";